import { AlertTriangle, X } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";

interface Props {
  historyTokenWarning: number | null;
  largeFolderWarning: number | null;
  onDismissHistoryToken: () => void;
  onDismissLargeFolder: () => void;
}

interface BannerProps {
  message: string;
  onDismiss: () => void;
}

const WarningBanner = ({ message, onDismiss }: BannerProps) => (
  <Alert variant="default" className="mb-2 flex items-center justify-between">
    <span className="flex items-center gap-2">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription>{message}</AlertDescription>
    </span>
    <button type="button" onClick={onDismiss} aria-label="Dismiss warning">
      <X className="h-4 w-4" />
    </button>
  </Alert>
);

export const AgentWarnings = ({
  historyTokenWarning,
  largeFolderWarning,
  onDismissHistoryToken,
  onDismissLargeFolder,
}: Props) => (
  <>
    {largeFolderWarning !== null && (
      <WarningBanner
        message={`This folder has ${largeFolderWarning} documents. Answers use the standard folder search rather than the guided agent.`}
        onDismiss={onDismissLargeFolder}
      />
    )}
    {historyTokenWarning !== null && (
      <WarningBanner
        message="This conversation is getting long, which may affect answer quality. Consider starting a new conversation."
        onDismiss={onDismissHistoryToken}
      />
    )}
  </>
);
